import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  MemberPreferenceConfigDto,
  MemberPreferenceConfigService,
} from '@services/MemberPreferenceConfigService'

export interface MemberPreferenceConfigState {
  config: MemberPreferenceConfigDto | null
  loading: boolean
}

const initialState: MemberPreferenceConfigState = {
  config: null,
  loading: false,
}

export const doGetMemberPreferenceConfig = createAsyncThunk<
  MemberPreferenceConfigDto,
  number
>('memberPreferenceConfig/get', (memberId) =>
  MemberPreferenceConfigService.getByMemberId(memberId),
)

export const doUpsertMemberPreferenceConfig = createAsyncThunk<
  MemberPreferenceConfigDto,
  MemberPreferenceConfigDto
>('memberPreferenceConfig/upsert', (dto) =>
  MemberPreferenceConfigService.upsert(dto),
)

export const memberPreferenceConfigSlice = createSlice({
  name: 'memberPreferenceConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(doGetMemberPreferenceConfig.pending, (state) => {
        state.loading = true
      })
      .addCase(doGetMemberPreferenceConfig.fulfilled, (state, action) => {
        state.config = action.payload
        state.loading = false
      })
      .addCase(doGetMemberPreferenceConfig.rejected, (state) => {
        state.loading = false
      })
      .addCase(doUpsertMemberPreferenceConfig.fulfilled, (state, action) => {
        state.config = action.payload
      })
  },
})

export default memberPreferenceConfigSlice.reducer
